export default __webpack_public_path__ + "static/media/image-main-2-m@2x.2caf326b.webp";